import { render, staticRenderFns } from "./AssessmentRules.vue?vue&type=template&id=2825987d&scoped=true&"
import script from "./AssessmentRules.vue?vue&type=script&lang=js&"
export * from "./AssessmentRules.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentRules.vue?vue&type=style&index=0&id=2825987d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825987d",
  null
  
)

export default component.exports